
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire11e5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire11e5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("giU2u", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $bde9cc018c642020$export$6503ec6e8aabbaf; }, function (v) { return $bde9cc018c642020$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $bde9cc018c642020$export$f7ad0328861e2f03; }, function (v) { return $bde9cc018c642020$export$f7ad0328861e2f03 = v; });
var $bde9cc018c642020$export$6503ec6e8aabbaf;
var $bde9cc018c642020$export$f7ad0328861e2f03;
"use strict";
var $bde9cc018c642020$var$mapping = new Map();
function $bde9cc018c642020$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$bde9cc018c642020$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $bde9cc018c642020$var$resolve(id) {
    var resolved = $bde9cc018c642020$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$bde9cc018c642020$export$6503ec6e8aabbaf = $bde9cc018c642020$var$register;
$bde9cc018c642020$export$f7ad0328861e2f03 = $bde9cc018c642020$var$resolve;

});

var $f1610d591fdfb1ab$exports = {};

(parcelRequire("giU2u")).register(new URL("", import.meta.url).toString(), JSON.parse('["a5vLB","index.24d80109.js","aqIiv","swadishLogo.7b70fc5e.png","eaaPg","Grocery.9fefdd5f.js"]'));


//# sourceMappingURL=index.runtime.baff61e9.js.map
